<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue';

const model = defineModel<boolean>({
  default: false,
});

function handleCloseClick(): void {
  model.value = false;
}

function handleKeydown(event: KeyboardEvent): void {
  if (event.code === 'Escape') {
    handleCloseClick();
  }
}

onMounted(() => {
  window.addEventListener('keydown', handleKeydown);
});

onUnmounted(() => {
  window.removeEventListener('keydown', handleKeydown);
});
</script>

<template>
  <v-menu
    v-model="model"
    :class="$style.dispatchPopoverVMenu"
    data-testid="dispatchPopoverVMenu"
  >
    <v-card :class="$style.card">
      <slot></slot>
    </v-card>
  </v-menu>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.dispatchPopoverVMenu {
}
  .card {
    overflow: visible !important;
  }
</style>
